/**
 * Auto-import Vuex store modules
 * Uses Vite's import.meta.glob instead of webpack's require.context
 */
const storeModules = import.meta.glob<any>("./**/*.store.ts", { eager: true });
const modules: any = {};

// Process each module and add it to the modules object
Object.entries(storeModules).forEach(([filePath, module]) => {
  // Extract the module name from file path
  // e.g., "./user.store.ts" -> "user"
  const moduleName = filePath.replace(/(\.\/|\.store\.ts)/g, "").replace(/^\w/, (c: string) => c.toLowerCase());

  // Add the module to our modules object
  modules[moduleName] = module.default || module;
});

export default modules;
